<template>
    <div class="page-container extend-main no-GPU" :style="{ backgroundImage: `url(${pageBgData ? pageBgData.img : ''})` }">
        <div class="page-body">
            <div class="page-logo">
                <img :src="pageLogoData ? pageLogoData.img : ''" alt="">
            </div>
            <template v-for="elementData in pageElementListData">
                <!-- 一行一张图片 -->
                <template v-if="elementData.contentType === 'img-1'">
                    <div class="img-1">
                        <img :src="elementData.img" alt="">
                    </div>
                </template>
                <!-- 白荆回廊-按钮图片 -->
                <template v-else-if="elementData.contentType === 'floatimg'">
                    <div class="floatimg" @click="btnEvent(elementData)">
                        <img :src="elementData.img" alt="">
                    </div>
                </template>
                <!-- 活动细则文本 -->
                <template v-else-if="elementData.contentType === 'richtext'">
                    <div class="richtext" v-html="elementData.content">
                    </div>
                </template>
                <!-- 视频 -->
                <template v-else-if="elementData.contentType === 'video'">
                    <div class="video" :style="{ height: elementData.height + 'px' }">
                        <video :poster="elementData.poster" :ref="(el) => mounteVideo(el, elementData)" controls>
                            <source v-for="source in elementData.sources" :src="source.src" :type="source.type">
                        </video>
                        <div v-if="!elementData.posterHidden" class="poster" @click="posterClick(elementData)">
                            <img :src="elementData.poster" />
                        </div>
                    </div>
                </template>

            </template>
        </div>
    </div>
</template>

<script>
// url处理
import $URL from '@utils/url'
// cms
import { CMS_Methods } from '@comm/store/cms.store';

const { computedUrl } = $URL;



export default {
    name: 'activeGameBaijingCorridor',
    components: {

    },
    data() {
        return {
            // 页面元素列表数据
            pageElementListData: [],
            // 页面logo数据
            pageLogoData: null,
            // 页面背景数据
            pageBgData: null,
        }
    },
    mounted() {
    },
    created() {
        // 初始化
        this.init();
    },
    methods: {
        // 初始化
        init() {
            CMS_Methods.baijingCorridor_game().then(({ bg, logo, elementList }) => {
                this.pageBgData = bg;
                this.pageLogoData = logo;
                this.pageElementListData = elementList;
            })
            // 神策埋点:页面浏览
            this.$Sensors.track('BJHLPageView', { page_name: "官网白荆回廊合作活动页" })
        },
        // 点击视频封面
        posterClick(elementData) {
            const videoElement = elementData.el;
            videoElement.play();
            elementData.posterHidden = true

            // CDP埋点 [点击视频播放]
            this.$CDP.track('c_click_bjhlpage', {
                // 弹窗名称
                buttonId: '',
                // 按钮名称
                c_buttonName: '播放视频',
            })
            // 神策埋点:点击视频播放
            this.$Sensors.track('BJHLPageClick', { page_name: "官网白荆回廊合作活动页", button_name: '播放视频' })
        },
        // 挂载视频
        mounteVideo(el, elementData) {
            if (el && el.offsetHeight) {
                elementData.el = el;

                // 元素真实尺寸
                const realWidth = el.offsetWidth;
                const realHeight = el.offsetWidth / elementData.width * elementData.height

                elementData.width = realWidth;
                elementData.height = realHeight;

                // 元素尺寸设置
                el.style.height = realHeight + 'px';
                el.parentNode.style.height = realHeight + 'px';

                // el.play();

            }
        },
        // 按钮点击事件
        btnEvent(elementData) {
            let pathInfo = elementData.path;
            let queryData = { originChannel: 'HZ' }

            // 按钮数据类型判断
            switch (typeof pathInfo) {
                case 'string':
                    pathInfo = computedUrl(pathInfo, queryData)
                    break;
                case 'object':
                    if (pathInfo.query) {
                        pathInfo.query = Object.assign(pathInfo.query, queryData);
                    } else if (pathInfo.path) {
                        pathInfo.path = computedUrl(pathInfo.path, queryData)
                    }
                    break;
                default:
                    break;

            }
            // CDP埋点 [跳转点餐页面]
            this.$CDP.track('c_click_bjhlpage', {
                // 弹窗名称
                buttonId: '',
                // 按钮名称
                c_buttonName: '点餐页面',
            })
            // 神策埋点:跳转点餐页面
            this.$Sensors.track('BJHLPageClick', { page_name: "官网白荆回廊合作活动页", button_name: '点餐页面' })

            // 页面跳转
            this.$routePush(pathInfo || 'page://menu?originChannel=HZ')
        }
    },
    computed: {
        player() {
            return this.$refs.videoPlayer.player
        }
    },
}

</script>

<style lang="scss" scoped>
.page-container {
    width: 100%;
    height: 100%;
    overflow-y: scroll;
    // background-size: contain;
    background-repeat: repeat;
    background-position: top;
}

.page-body {
    width: 100%;
    padding: 0 5px;

    // div {
    //     border: dashed 1px green;
    // }

    .richtext {
        color: white;
        font-weight: bold;
        font-size: 15px;
        padding: 3px 10px;
    }

    .video {
        padding: 0 5px;
        width: 100%;
        position: relative;

        video {
            width: 100%;
            height: 100%;
        }

        .poster {
            top: 0;
            left: 0;
            position: absolute;
            width: 100%;
            height: 100%;
            background-size: contain;
            background-repeat: no-repeat;
            background-position: center;

            img {
                width: 100%;
                height: 100%;
            }
        }
    }

    .img-2 {
        img {
            width: 100%;
        }
    }

    .img-1,
    .floatimg {
        img {
            width: 100%;
        }
    }

    .floatimg{
        bottom: 0;
        position: fixed;
    }
}

.page-logo {
    top: 0;
    height: 45px;
    width: 100%;
    padding: 10px;
    position: absolute;

    img {
        height: 100%;
    }
}
</style>
